import React, { forwardRef } from "react"
import { classNames } from "../../utils"
import { Flex, FlexProps } from "../Flex/Flex"

export type FlexStartProps = FlexProps

export const FlexStart = forwardRef<HTMLDivElement, FlexStartProps>(
  function FlexStart({ className, ...rest }, ref) {
    return (
      <Flex
        className={classNames("justify-start", className)}
        ref={ref}
        {...rest}
      />
    )
  },
)
